import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { UserDetails } from '@/models/UserDetails.model';
import { SmsSendingStatus } from '@/models/SmsSendingStatus';
import { IndexAndOfficesRequest } from '@/models/request/index-and-offices-request';
import { OidcUserManager } from '@/models/OidcUserManager.model';

export interface AuthenticationState {
  userDetails: UserDetails | null;
  authLoadingMode: boolean;
  otpSent: boolean;
  gov: string;
  authErrors: string[];
  smsSending: SmsSendingStatus;
  selectAuthMethodErrors: string[];
  lastSsoUsedToken: string;
  isRecaptchaV2Used: boolean;
  indexAndOfficesList: IndexAndOfficesRequest[];
  uploadFileEnable: boolean;
  oidcId: string | null;
  oidcUserManager: OidcUserManager | null;

}

export const initialState = ((): AuthenticationState => {
  return {
    userDetails: null,
    authLoadingMode: false,
    otpSent: false,
    gov: '',
    authErrors: [],
    smsSending: SmsSendingStatus.NOT_SENDING,
    selectAuthMethodErrors: [],
    lastSsoUsedToken: '',
    isRecaptchaV2Used: false,
    indexAndOfficesList: [],
    uploadFileEnable: true,
    oidcId: null,
    oidcUserManager: null,
  };
});

export const authentication: Module<AuthenticationState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
